export enum DataHooks {
  TimeSlotsNotification = 'time-slots-notification',
  CTA = 'time-slots-notification-cta',
}
